import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fillRule="evenodd" d="M7.97 19.53a.75.75 0 010-1.06L14.44 12 7.97 5.53a.75.75 0 011.06-1.06l7 7a.75.75 0 010 1.06l-7 7a.75.75 0 01-1.06 0" clipRule="evenodd" /></svg>;